import IqosOriginalsChanges from './IqosOriginalsChanges';
export default IqosOriginalsChanges;
